/**
 * Persists only the computed prem-freebie ribbon flag (not fetchData) in a cookie.
 * Used when localStorage.fetchData is cleared (e.g. homepage) so ribbon logic can still run.
 */
(function () {
  var COOKIE_NAME = 'ds2_prem_freebie_flag';
  var COOKIE_MAX_AGE = 60 * 60 * 24 * 30;

  function getCookie(name) {
    var prefix = encodeURIComponent(name) + '=';
    var parts = (document.cookie || '').split(/;\s*/);
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].indexOf(prefix) === 0) {
        return decodeURIComponent(parts[i].slice(prefix.length));
      }
    }
    return null;
  }

  function setCookie(name, value, maxAge) {
    document.cookie =
      encodeURIComponent(name) +
      '=' +
      encodeURIComponent(value) +
      '; Path=/' +
      '; SameSite=Lax' +
      '; Secure' +
      '; Max-Age=' +
      Math.floor(maxAge);
  }

  function normalizeSfid(sfid) {
    return sfid != null ? String(sfid).trim() : '';
  }

  function containsFreePremInData(data) {
    var prem = window.PREM_REPORT;
    if (!prem || !data) return false;
    var skus =
      (data.subscriber_list &&
        Array.isArray(data.subscriber_list.subscribed_products) &&
        data.subscriber_list.subscribed_products) ||
      (Array.isArray(data.records) ? data.records : []);
    return skus.some(function (sku) {
      var s = String(sku);
      return s === prem || s.indexOf(prem) !== -1;
    });
  }

  function isEligibleFromData(data) {
    var count =
      data &&
      data.device_details &&
      data.device_details.total_device_count != null
        ? Number(data.device_details.total_device_count)
        : NaN;
    if (!Number.isFinite(count)) {
      count = parseInt(localStorage.getItem('total_device_count'), 10);
    }
    return Number.isFinite(count) && count >= 200;
  }

  /** @returns {boolean} true = show freemium ribbon */
  function computeShowFlag(data) {
    return isEligibleFromData(data) && !containsFreePremInData(data);
  }

  function readFlagEnvelope() {
    var raw = getCookie(COOKIE_NAME);
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  window.ds2PersistPremFreebieFlagFromFetchData = function (data, sfid) {
    var sfidNorm = normalizeSfid(sfid);
    if (!sfidNorm) return;

    var payload = data;
    if (typeof data === 'string') {
      try {
        payload = JSON.parse(data);
      } catch (e) {
        return;
      }
    }
    if (!payload || typeof payload !== 'object') return;

    var envelope = {
      v: 1,
      sfid: sfidNorm,
      show: computeShowFlag(payload) ? 1 : 0,
    };
    setCookie(COOKIE_NAME, JSON.stringify(envelope), COOKIE_MAX_AGE);
  };

  /** @returns {boolean|null} null if no valid cookie for this sfid */
  window.ds2GetPremFreebieShowFromCookie = function (sfid) {
    var envelope = readFlagEnvelope();
    if (!envelope || normalizeSfid(envelope.sfid) !== normalizeSfid(sfid)) {
      return null;
    }
    return envelope.show === 1 || envelope.show === true;
  };

  window.ds2SetPremFreebieShowCookie = function (sfid, show) {
    var sfidNorm = normalizeSfid(sfid);
    if (!sfidNorm) return;
    setCookie(
      COOKIE_NAME,
      JSON.stringify({ v: 1, sfid: sfidNorm, show: show ? 1 : 0 }),
      COOKIE_MAX_AGE
    );
  };
})();
